import React, { CSSProperties, ReactNode } from "react";
import { _ProductLineImageRoot } from "./ProductLineImage.styled";
import { Image } from "../../../Components/Image";

export interface IProductLineImageProps {
  id_object_picture?: string;
  image?: string | ((style: CSSProperties) => ReactNode);
  size?: number;
  style?: CSSProperties;
}

const ProductLineImage = (props: IProductLineImageProps) => {
  const { image, size = 77, id_object_picture, style } = props;
  const imageStyle: CSSProperties = {
    position: "absolute",
    left: 0,
    right: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };
  return (
    <_ProductLineImageRoot $size={size} style={style}>
      {!!id_object_picture ? (
        <Image
          image={{
            id: id_object_picture,
            width: size,
            aspectRatio: 1,
          }}
        />
      ) : typeof image === "string" ? (
        <img src={image} style={imageStyle} />
      ) : (
        image && image(imageStyle)
      )}
    </_ProductLineImageRoot>
  );
};

export default ProductLineImage;
